import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const LINKS = [
  { label: "About", href: "#about" },
  { label: "Writing", href: "#writing" },
  { label: "Podcast", href: "#podcast" },
  { label: "Speaking", href: "#speaking" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -70, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${scrolled ? "bg-ink/90 backdrop-blur-md border-b border-cream/10" : ""}`}
      data-testid="site-nav"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <a href="#top" data-testid="nav-home-link" className="font-display text-gold text-xl tracking-wide">
          R<span className="text-cream/60">·</span>C<span className="text-cream/60">·</span>K
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="eyebrow text-cream/70 hover:text-gold transition-colors duration-300">
              {l.label}
            </a>
          ))}
        </nav>
        <a href="#enquire" data-testid="nav-enquire-btn"
          className="eyebrow bg-gold text-ink px-5 py-2.5 rounded-full hover:bg-cream transition-colors duration-300">
          Enquire
        </a>
      </div>
    </motion.header>
  );
};
